import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const money = (v) =>
  new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(v || 0);

export const money2 = (v) =>
  new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(v || 0);

export const num = (v) => new Intl.NumberFormat("es-EC").format(v || 0);

export const STATUS_LABEL = {
  borrador: "Borrador",
  enviada: "Enviada",
  en_negociacion: "En negociación",
  aprobada: "Aprobada",
  rechazada: "Rechazada",
  expirada: "Expirada",
};

export const STATUS_COLOR = {
  borrador: "bg-spott-mid text-spott-blue",
  enviada: "bg-spott-blue text-white",
  en_negociacion: "bg-spott-yellow text-spott-blue",
  aprobada: "bg-emerald-600 text-white",
  rechazada: "bg-red-600 text-white",
  expirada: "bg-gray-400 text-white",
};

export const STAGES = [
  { id: "awareness", label: "Awareness", hint: "Notoriedad y alcance masivo" },
  { id: "conversion", label: "Conversión", hint: "Impacto en la decisión de compra" },
];

export const OBJECTIVES = [
  { id: "awareness", label: "Awareness", hint: "Notoriedad y alcance masivo" },
  { id: "conversion", label: "Conversión", hint: "Impacto en la decisión de compra" },
  { id: "expansion", label: "Expansión regional", hint: "Abrir cobertura en nuevas plazas del país" },
];

export const REDEMPTION_STATUS = {
  solicitado: { label: "Solicitado", cls: "bg-spott-yellow text-spott-blue" },
  aprobado: { label: "Aprobado", cls: "bg-spott-blue text-white" },
  ejecutado: { label: "Ejecutado", cls: "bg-emerald-600 text-white" },
  rechazado: { label: "Rechazado", cls: "bg-red-600 text-white" },
};

export const CAMPAIGN_STATUS = {
  pendiente: { label: "Pendiente", cls: "bg-spott-mid text-spott-blue" },
  en_proceso: { label: "En proceso", cls: "bg-spott-yellow text-spott-blue" },
  ejecutado: { label: "Ejecutado", cls: "bg-emerald-600 text-white" },
};

export const LOAD_STATUS = {
  completo: { label: "Carga completa", cls: "bg-emerald-100 text-emerald-700" },
  incompleto: { label: "Carga incompleta", cls: "bg-amber-100 text-amber-700" },
  sin_carga: { label: "Sin carga de producto", cls: "bg-red-100 text-red-700" },
};

export const AGE_RANGES = ["18-24", "25-34", "35-44", "45-54", "55+"];
export const GENDERS = ["Femenino", "Masculino", "Todos"];
export const NSE = ["A", "B", "C", "D"];
export const RETAILER_TYPES = ["supermercado", "farmacia", "centro comercial", "tienda especializada"];
export const BUDGETS = [
  { id: "<5k", label: "Menos de $5.000" },
  { id: "5k-15k", label: "$5.000 – $15.000" },
  { id: "15k-50k", label: "$15.000 – $50.000" },
  { id: "50k-150k", label: "$50.000 – $150.000" },
  { id: "150k-500k", label: "$150.000 – $500.000" },
  { id: ">500k", label: "Más de $500.000" },
];
export const INDUSTRIES = [
  "Alimentos y bebidas", "Cuidado personal", "Farmacéutica", "Hogar y limpieza",
  "Tecnología", "Moda y retail", "Automotriz", "Servicios financieros", "Telecomunicaciones", "Otro",
];
